(function($) {$(document).ready(function() {

	$('body').append('<div class="vid-box"></div>');

	$('[data-open-video]').on('click', vidLinkClick);
	
	$('.vid-box').on('click', '.vid-box__close', closeBox);
	$('.vid-box').on('click', event => {
		if (event.target === event.currentTarget) closeBox();
	});

	function vidLinkClick(event) {
		openBox($(this).attr('data-open-video'));
	}
	
	function openBox(vidId) {
		let w = window.innerWidth < 1024 ? 320 : 1211;
		let h = window.innerWidth < 1024 ? 180 : 681;
		let embed = `<iframe class="vid-box__vid" width="${w}" height="${h}" src="https://www.youtube.com/embed/${vidId}?controls=0&autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe><div class="vid-box__close"></div>`;
		$('.vid-box').html(embed).fadeIn();
	}
	
	function closeBox() {
		$('.vid-box').fadeOut(500, function() {
			$(this).html('');
		});
	}
});;jQueryBridget("flickity", Flickity, $);})(window.NEW_jquery);